export const LOGIN_FAILED_ERROR =
    'Unable to login, please try again or contact your Account Manager.';

//Login Form Validation
export const LOGIN_FORM_VID_FORMAT = 'please enter a valid number';

//Quotes Page
export const QUOTES_PAGE_TITLE = 'Calculate Lease Quote';
export const QUOTES_SEND_QUOTE_TITLE = 'Where and to Whom is the quote going?';
export const QUOTES_LEASE_TYPE = [
    { id: 0, text: 'Stretch', value: 'Stretch' },
    { id: 1, text: '10 @ end', value: '10 @ end' },
    { id: 2, text: 'FMV @ end', value: 'FMV @ end' }
];
export const OUOTES_TERMS = {
    24: {
        label: '24/27 Months'
    },
    36: {
        label: '36/40 Months'
    },
    48: {
        label: '48/52 Months'
    },
    60: {
        label: '60/66 Months'
    }
};

export const QUOTES_BTN_CALC_QUOTE = 'Calculate Quote';
export const QUOTES_LBL_EQUIPMENT_COST = 'Equipment Cost (Before tax)';
export const QUOTES_LBL_LEASE_TYPE = 'Lease Type';
export const QUOTES_BTN_SAVE_AND_SEND = 'Send Quote';
export const QUOTES_BTN_PREVIEW = 'Preview Quote';
export const QUOTES_BTN_SEND_QUOTE_TO_CUSTOMER = 'Send Quote to Customer';
export const QUOTES_BTN_BACK = 'Back';
export const QUOTES_ERROR_CREATING_QUOTE_TITLE = 'Could Not Create Quote';
export const QUOTES_ERROR_CREATING_QUOTE_MSG =
    'Unable to successfully create quote. Please try again.';
export const QUOTES_ERROR_SENDING_QUOTE_TITLE = 'Could Not Send Quote';
export const QUOTES_ERROR_SENDING_QUOTE_MSG =
    'Unable to successfully send quote. Please try again.';
export const QUOTES_NOTIFICATION_SENT_TITLE = 'Quote Sent';
export const QUOTES_NOTIFICATION_SENT_BODY =
    'Your quote has been sent successfully.';
export const QUOTES_MONTHLY_PAYMENTS =
    'Monthly Payments(Check only terms you want)';
export const QUOTES_EMAIL_MESSAGE_DEFAULT =
    'Please find attached our equipment lease quote on the asset we discussed. Please advise if you would like to proceed with an easy and quick credit approval. Feel free to contact me with any questions.';
export const QUOTES_EQUIPMENT_PLACEHOLDER =
    'Description of what you are quoting on';
export const QUOTES_BUSINESS_NAME_PLACEHOLDER = "Your customer's business name";
export const QUOTES_CONTACT_NAME_PLACEHOLDER = 'Who will receive the quote?';

//Credit
export const CREDIT_FULL_LEGAL_NAME = 'Full Legal Name';
export const CREDIT_FULL_LEGAL_NAME_PLACEHOLDER = 'Example Company';
export const CREDIT_BUSINESS_NAME = 'Business Name';
export const CREDIT_BUSINESS_NAME_PLACEHOLDER = 'Operating As';
export const CREDIT_BUSINESS_TYPE = 'Business Type';
export const CREDIT_BUSINESS_TYPE_OPTIONS = [
    { id: 0, text: 'Limited/Incorporated', value: 'Incorporated' },
    { id: 1, text: 'Proprietorship', value: 'Proprietorship' }
];
export const CREDIT_YEARS_IN_BUSINESS = 'Years in Business';
export const CREDIT_YEARS_IN_BUSINESS_PLACEHOLDER = 20;
export const CREDIT_BTN_NEXT = 'Next';
export const CREDIT_BTN_SUBMIT = 'Submit';

export const ADDRESS = 'Address';
export const ADDRESS_PLACEHOLDER = '123 Example Street';
export const CITY = 'City';
export const CITY_PLACEHOLDER = 'Toronto';
export const PROVINCE = 'Province';
export const PROVINCE_PLACEHOLDER = 'Ontario';
export const PROVINCES = [
    { id: 0, text: 'Alberta', value: 'Alberta' },
    { id: 1, text: 'British Columbia', value: 'British Columbia' },
    { id: 2, text: 'Manitoba', value: 'Manitoba' },
    { id: 3, text: 'New Brunswick', value: 'New Brunswick' },
    {
        id: 4,
        text: 'Newfoundland and Labrador',
        value: 'Newfoundland and Labrador'
    },
    { id: 5, text: 'Northwest Territories', value: 'Northwest Territories' },
    { id: 6, text: 'Nova Scotia', value: 'Nova Scotia' },
    { id: 7, text: 'Nunavut', value: 'Nunavut' },
    { id: 8, text: 'Ontario', value: 'Ontario' },
    { id: 9, text: 'Prince Edward Island', value: 'Prince Edward Island' },
    { id: 10, text: 'Quebec', value: 'Quebec' },
    { id: 11, text: 'Saskatchewan', value: 'Saskatchewan' },
    { id: 12, text: 'Yukon', value: 'Yukon' }
];
export const CREDIT_CONTACT_NAME = 'Contact Name';
export const CREDIT_CONTACT_NAME_PLACEHOLDER = 'John Doe';
export const CREDIT_CONTACT_EMAIL = 'Contact Email';
export const CREDIT_CONTACT_EMAIL_PLACEHOLDER = 'john.doe@example.com';
export const CREDIT_TERM = 'Term';
export const CREDIT_TERMS = [
    { id: 0, text: 24, value: '24M' },
    { id: 1, text: 36, value: '36M' },
    { id: 2, text: 48, value: '48M' },
    { id: 3, text: 60, value: '60M' }
];
export const CREDIT_COST = 'Cost';
export const CREDIT_ASSET = 'Asset';
export const CREDIT_ASSET_CONDITION = [
    { id: 0, text: 'New', value: 'New' },
    { id: 1, text: 'Used', value: 'Used' }
];

export const CREDIT_BUSINESS_PHONE = 'Business Phone';
export const CREDIT_SIN = 'SIN';
export const CREDIT_DOB = 'Date of Birth';
export const CREDIT_TERM_PLACEHOLDER = '36';
export const CREDIT_COST_PLACEHOLDER = '$';
export const CREDIT_ASSET_PLACEHOLDER = 'eg. Trailer';
export const CREDIT_BUSINESS_PHONE_PLACEHOLDER = '555-555-5555 ';
export const CREDIT_SIN_PLACEHOLDER = '123 456 789';
export const CREDIT_DOB_PLACEHOLDER = '1984/01/27';

export const LOGIN_LBL_USER_NAME = 'User Name';
export const LOGIN_LBL_PASSWORD = 'Password';
export const LOGIN_BTN_SIGN_IN = 'Sign In';
export const LOGIN_TXT_FORGOT_PASSWORD = 'Forgot Password?';

//Password Reset
export const PASSWORD_RESET_SAVE = 'Save Password';



// WEBPACK FOOTER //
// ./src/app/utils/strings.js